const options = {
    use: true
};
export default options;
